export default __webpack_public_path__ + "static/media/carousel-right-arrow-dark.fa6f6f7c.svg";